<template>
  <b-modal id="updateAgreementSlaModal" size="xl" hide-footer @hidden="resetData">
    <b-row slot="modal-header">
      <b-col>
        <h6>{{ $t('modals.excmagreementsla.updateAgreementSlaHeader') }}</h6>
      </b-col>
    </b-row>
    <b-row v-if="agreementSla">
      <b-col>
        <EXCMAgreementSlaUpdate :agreementSlaId="agreementSla['@id']"></EXCMAgreementSlaUpdate>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import EXCMAgreementSlaUpdate from '../Update.vue'
import getId from '@/utils/getIdFromLink'
export default {
  name: 'UpdateAgreementDeviceModal',
  components: {
    EXCMAgreementSlaUpdate
  },
  computed: {
    show () {
      return this.$store.state.modals.excmagreementsla.update.show
    },
    slaPivot () {
      return this.$store.state.modals.excmagreementsla.update.slaPivot
    },
    close () {
      return this.$store.state.modals.excmagreementsla.update.close
    }
  },
  watch: {
    'show': function (val) {
      this.openModal()
    },
    'slaPivot': function (val) {
      this.openModal()
    },
    'close': function (val) {
      this.closeModal()
    }
  },
  data () {
    return {
      agreementSla: null
    }
  },
  methods: {
    openModal () {
      if (this.show === 1 && this.slaPivot) {
        this.agreementSla = Object.assign({}, this.slaPivot)
        this.$store.state.modals.excmagreementsla.update.show = 0
        this.$store.state.modals.excmagreementsla.update.slaPivot = null
        this.$bvModal.show('updateAgreementSlaModal')
      }
    },
    closeModal () {
      if (this.close === 1) {
        this.$store.state.modals.excmagreementsla.update.close = 0
        this.$bvModal.hide('updateAgreementSlaModal')
      }
    },
    getIdLink (link) {
      return getId(link)
    },
    resetData () {
      // console.log()
    }
  }
}
</script>
